import { Component, OnInit } from '@angular/core';

import { Questionnaire } from '../../models/questionnaire';

import { PatientQuestionnaireService } from '../../services/patient-questionnaire.service';
import { GroupService } from '../../services/group.service';
import { NaviService } from '../../services/navi.service';
import { BasicError, Error403 } from '../../models/error/error';

@Component({
  selector: 'app-my-questionnaires',
  templateUrl: './my-questionnaires.component.html',
  styleUrls: ['./my-questionnaires.component.css']
})
export class MyQuestionnairesComponent implements OnInit {
  public myObj = [];
  public isEmpty = false;
  public amountElements = {};
  public myStudies = [];
  public myStudiesFilled = {};
  public questionnaireToStudyMap = {};
  public studyMap = {};
  public questionnaireMap = {};

  // Var to navigate
  public questionnaireDetailUrl: String;

  constructor(private myQuestionnares: PatientQuestionnaireService, private naviService: NaviService, private groupService: GroupService) {
    this.getMyQuestionnaires();

    if (this.myObj.length === 0) {
      this.isEmpty = true;
    }

  }

  ngOnInit() {
  }

  public getMyQuestionnaires() {
    this.myQuestionnares.getMyQuestionnairesOfStudy().subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      } else {
        this.myObj = data;

        for (let i = 0; i < data.length; i++) {
          this.getAmountOfMyQuestionnaireElements(data[i]);
        }

        for (const quest of this.myObj) {
          this.questionnaireMap[quest.getId().toString()] = quest;
        }

        if (this.myObj.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
      }

      this.getMyStudies();
    });
  }

  public getMyStudies() {
    this.groupService.getMyGroups().subscribe(data => {
      if (data instanceof BasicError) {
        console.log('Failed in loading my studies');
        return;
      }

      this.myStudies = data;

      for (const study of this.myStudies) {
        this.studyMap[study.getId().toString()] = study;
        this.getQuestionnairesOfStudy(study);
      }
    });
  }

  public getQuestionnairesOfStudy(study) {
    this.myQuestionnares.getQuestionnairesOfStudy(study.getId()).subscribe(dd => {
      if (dd instanceof BasicError) {
        return;
      }

      let isFilled = true;

      for (const quest of dd) {
        if (quest instanceof Questionnaire) {
          this.questionnaireToStudyMap[quest.getId().toString()] = study.getId();
          if (this.questionnaireMap[quest.getId().toString()] &&
            this.questionnaireMap[quest.getId().toString()].isOneTime() && !this.questionnaireMap[quest.getId().toString()].isFilledOut()) {
            isFilled = false;
          }
        }
      }

      this.myStudiesFilled[study.getId().toString()] = isFilled;
    });
  }

  public getAmountOfMyQuestionnaireElements(qu: Questionnaire) {

    this.myQuestionnares.getMyQuestionnaireStructure(qu).subscribe(data => {
      if (data instanceof BasicError) {
        console.log(data);
      } else {
        this.amountElements[qu.getId().toString()] = data.length - 1;
      }
    });
  }

  public navigateToMyQuestionnaireDetail(stId: String) {
    this.questionnaireDetailUrl = 'myquestionnaires/' + stId;

    this.naviService.navigateToUrl(this.questionnaireDetailUrl, 'myquestionnaires');
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/my-questionnaires/my-questionnaires.component.ts